import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { SelectModel } from '../../models/select.model';
import { MortgageService } from '../../services/mortgage/mortgage.service';

@Component({
  selector: 'app-address-data-form',
  templateUrl: './address-data-form.component.html',
  styleUrls: ['./address-data-form.component.scss'],
  standalone: false,
})
export class AddressDataFormComponent implements OnInit {
  @Input() addressForm: UntypedFormGroup;
  @Input() HTML_VALIDATORS: any;
  @Input() holder: number = 0;
  @Output() onSaveAddressData: EventEmitter<any> = new EventEmitter();

  listRoadType$: Observable<Array<SelectModel>>;

  constructor(private _mortgageService: MortgageService) {}

  ngOnInit() {
    this.listRoadType$ = this._mortgageService.getRoadType();
  }

  saveForm() {
    this.onSaveAddressData.emit();
  }
}
